import { jsx } from "react/jsx-runtime";
import { useRef, useCallback } from "react";
import { Search } from "./components/Search.js";
import { Stack } from "@mui/material";
import { useDropdownContext } from "./context/DropdownContext.js";
const DropdownSearchPanel = ({ onSearch }) => {
  const ctx = useDropdownContext(), ref = useRef({ onSearch });
  ref.current = { onSearch };
  const handleSearch = useCallback((str) => {
    ref.current.onSearch(str);
  }, []);
  return /* @__PURE__ */ jsx(Stack, { sx: ctx.mobileView ? { paddingX: 18, paddingY: 12 } : {}, children: /* @__PURE__ */ jsx(Search, { onSearch: handleSearch, mobileView: !!ctx.mobileView }) });
};
export {
  DropdownSearchPanel
};
//# sourceMappingURL=DropdownSearchPanel.js.map
